/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Qwick Core API
 * AKA V3, AKA Gigpro, AKA sidegig-api
 * OpenAPI spec version: 0.0.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  Event,
  EventGigCreateRequest,
  EventRequest,
  EventShiftCreateRequest,
  EventsShiftsListParams,
  GigMetadata,
  GigShift,
  GigShiftSerializerWithGigs,
  PatchedEventRequest
} from '../model';

import { customFetch } from '../../custom-fetch';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getEventsListUrl = () => {




  return `/api/events/`
}

/**
 * Event object describes an event at a venue (e.g. 'Pete & Amy's Wedding')
 */
export const eventsList = async ( options?: Parameters<typeof customFetch>[1]): Promise<Event[]> => {

  return customFetch<Event[]>(getEventsListUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getEventsListQueryKey = () => {
    return [
    `/api/events/`
    ] as const;
    }


export const getEventsListQueryOptions = <TData = Awaited<ReturnType<typeof eventsList>>, TError = void>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof eventsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getEventsListQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof eventsList>>> = ({ signal }) => eventsList({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof eventsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type EventsListQueryResult = NonNullable<Awaited<ReturnType<typeof eventsList>>>
export type EventsListQueryError = void


export function useEventsList<TData = Awaited<ReturnType<typeof eventsList>>, TError = void>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof eventsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof eventsList>>,
          TError,
          Awaited<ReturnType<typeof eventsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useEventsList<TData = Awaited<ReturnType<typeof eventsList>>, TError = void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof eventsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof eventsList>>,
          TError,
          Awaited<ReturnType<typeof eventsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useEventsList<TData = Awaited<ReturnType<typeof eventsList>>, TError = void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof eventsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useEventsList<TData = Awaited<ReturnType<typeof eventsList>>, TError = void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof eventsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getEventsListQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getEventsCreateUrl = () => {




  return `/api/events/`
}

/**
 * Event object describes an event at a venue (e.g. 'Pete & Amy's Wedding')
 */
export const eventsCreate = async (eventRequest: EventRequest, options?: Parameters<typeof customFetch>[1]): Promise<Event> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<Event>(getEventsCreateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(eventRequest)
  }
);}





export const getEventsCreateMutationKey = () => ['eventsCreate'] as const;

export const getEventsCreateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof eventsCreate>>, TError,EventsCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof eventsCreate>>, TError,EventsCreateMutationVariables, TContext> => {

const mutationKey = getEventsCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof eventsCreate>>, EventsCreateMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  eventsCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type EventsCreateMutationResult = NonNullable<Awaited<ReturnType<typeof eventsCreate>>>
    export type EventsCreateMutationBody = EventRequest
    export type EventsCreateMutationError = void
    export type EventsCreateMutationVariables = {data: EventRequest}

    export const useEventsCreate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof eventsCreate>>, TError,EventsCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof eventsCreate>>,
        TError,
        EventsCreateMutationVariables,
        TContext
      > => {
      return useMutation(getEventsCreateMutationOptions(options), queryClient);
    }
    export const getEventsGigsListUrl = (eventId: string,) => {




  return `/api/events/${eventId}/gigs/`
}

/**
 * Link gigs to an event.
 *
 * Events group multiple gigs together (e.g. a catering event with separate
 * Server, Bartender, and Cook gigs).
 */
export const eventsGigsList = async (eventId: string, options?: Parameters<typeof customFetch>[1]): Promise<GigMetadata[]> => {

  return customFetch<GigMetadata[]>(getEventsGigsListUrl(eventId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getEventsGigsListQueryKey = (eventId: string,) => {
    return [
    `/api/events/${eventId}/gigs/`
    ] as const;
    }


export const getEventsGigsListQueryOptions = <TData = Awaited<ReturnType<typeof eventsGigsList>>, TError = void>(eventId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof eventsGigsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getEventsGigsListQueryKey(eventId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof eventsGigsList>>> = ({ signal }) => eventsGigsList(eventId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: eventId !== null && eventId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof eventsGigsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type EventsGigsListQueryResult = NonNullable<Awaited<ReturnType<typeof eventsGigsList>>>
export type EventsGigsListQueryError = void


export function useEventsGigsList<TData = Awaited<ReturnType<typeof eventsGigsList>>, TError = void>(
 eventId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof eventsGigsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof eventsGigsList>>,
          TError,
          Awaited<ReturnType<typeof eventsGigsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useEventsGigsList<TData = Awaited<ReturnType<typeof eventsGigsList>>, TError = void>(
 eventId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof eventsGigsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof eventsGigsList>>,
          TError,
          Awaited<ReturnType<typeof eventsGigsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useEventsGigsList<TData = Awaited<ReturnType<typeof eventsGigsList>>, TError = void>(
 eventId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof eventsGigsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useEventsGigsList<TData = Awaited<ReturnType<typeof eventsGigsList>>, TError = void>(
 eventId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof eventsGigsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getEventsGigsListQueryOptions(eventId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getEventsGigsCreateUrl = (eventId: string,) => {




  return `/api/events/${eventId}/gigs/`
}

/**
 * Link gigs to an event.
 *
 * Events group multiple gigs together (e.g. a catering event with separate
 * Server, Bartender, and Cook gigs).
 */
export const eventsGigsCreate = async (eventId: string,
    eventGigCreateRequest: EventGigCreateRequest, options?: Parameters<typeof customFetch>[1]): Promise<GigMetadata[]> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<GigMetadata[]>(getEventsGigsCreateUrl(eventId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(eventGigCreateRequest)
  }
);}





export const getEventsGigsCreateMutationKey = () => ['eventsGigsCreate'] as const;

export const getEventsGigsCreateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof eventsGigsCreate>>, TError,EventsGigsCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof eventsGigsCreate>>, TError,EventsGigsCreateMutationVariables, TContext> => {

const mutationKey = getEventsGigsCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof eventsGigsCreate>>, EventsGigsCreateMutationVariables> = (props) => {
          const {eventId,data} = props ?? {};

          return  eventsGigsCreate(eventId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type EventsGigsCreateMutationResult = NonNullable<Awaited<ReturnType<typeof eventsGigsCreate>>>
    export type EventsGigsCreateMutationBody = EventGigCreateRequest
    export type EventsGigsCreateMutationError = void
    export type EventsGigsCreateMutationVariables = {eventId: string;data: EventGigCreateRequest}

    export const useEventsGigsCreate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof eventsGigsCreate>>, TError,EventsGigsCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof eventsGigsCreate>>,
        TError,
        EventsGigsCreateMutationVariables,
        TContext
      > => {
      return useMutation(getEventsGigsCreateMutationOptions(options), queryClient);
    }
    export const getEventsShiftsListUrl = (eventId: string,
    params?: EventsShiftsListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/events/${eventId}/shifts/?${stringifiedParams}` : `/api/events/${eventId}/shifts/`
}

/**
 * EventShift object connects multiple gig shifts to an event
 */
export const eventsShiftsList = async (eventId: string,
    params?: EventsShiftsListParams, options?: Parameters<typeof customFetch>[1]): Promise<GigShiftSerializerWithGigs[]> => {

  return customFetch<GigShiftSerializerWithGigs[]>(getEventsShiftsListUrl(eventId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getEventsShiftsListQueryKey = (eventId: string,
    params?: EventsShiftsListParams,) => {
    return [
    `/api/events/${eventId}/shifts/`, ...(params ? [params] : [])
    ] as const;
    }


export const getEventsShiftsListQueryOptions = <TData = Awaited<ReturnType<typeof eventsShiftsList>>, TError = void>(eventId: string,
    params?: EventsShiftsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof eventsShiftsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getEventsShiftsListQueryKey(eventId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof eventsShiftsList>>> = ({ signal }) => eventsShiftsList(eventId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: eventId !== null && eventId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof eventsShiftsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type EventsShiftsListQueryResult = NonNullable<Awaited<ReturnType<typeof eventsShiftsList>>>
export type EventsShiftsListQueryError = void


export function useEventsShiftsList<TData = Awaited<ReturnType<typeof eventsShiftsList>>, TError = void>(
 eventId: string,
    params: undefined |  EventsShiftsListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof eventsShiftsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof eventsShiftsList>>,
          TError,
          Awaited<ReturnType<typeof eventsShiftsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useEventsShiftsList<TData = Awaited<ReturnType<typeof eventsShiftsList>>, TError = void>(
 eventId: string,
    params?: EventsShiftsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof eventsShiftsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof eventsShiftsList>>,
          TError,
          Awaited<ReturnType<typeof eventsShiftsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useEventsShiftsList<TData = Awaited<ReturnType<typeof eventsShiftsList>>, TError = void>(
 eventId: string,
    params?: EventsShiftsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof eventsShiftsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useEventsShiftsList<TData = Awaited<ReturnType<typeof eventsShiftsList>>, TError = void>(
 eventId: string,
    params?: EventsShiftsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof eventsShiftsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getEventsShiftsListQueryOptions(eventId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getEventsShiftsCreateUrl = (eventId: string,) => {




  return `/api/events/${eventId}/shifts/`
}

/**
 * EventShift object connects multiple gig shifts to an event
 */
export const eventsShiftsCreate = async (eventId: string,
    eventShiftCreateRequest: EventShiftCreateRequest, options?: Parameters<typeof customFetch>[1]): Promise<GigShift[]> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<GigShift[]>(getEventsShiftsCreateUrl(eventId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(eventShiftCreateRequest)
  }
);}





export const getEventsShiftsCreateMutationKey = () => ['eventsShiftsCreate'] as const;

export const getEventsShiftsCreateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof eventsShiftsCreate>>, TError,EventsShiftsCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof eventsShiftsCreate>>, TError,EventsShiftsCreateMutationVariables, TContext> => {

const mutationKey = getEventsShiftsCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof eventsShiftsCreate>>, EventsShiftsCreateMutationVariables> = (props) => {
          const {eventId,data} = props ?? {};

          return  eventsShiftsCreate(eventId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type EventsShiftsCreateMutationResult = NonNullable<Awaited<ReturnType<typeof eventsShiftsCreate>>>
    export type EventsShiftsCreateMutationBody = EventShiftCreateRequest
    export type EventsShiftsCreateMutationError = void
    export type EventsShiftsCreateMutationVariables = {eventId: string;data: EventShiftCreateRequest}

    export const useEventsShiftsCreate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof eventsShiftsCreate>>, TError,EventsShiftsCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof eventsShiftsCreate>>,
        TError,
        EventsShiftsCreateMutationVariables,
        TContext
      > => {
      return useMutation(getEventsShiftsCreateMutationOptions(options), queryClient);
    }
    export const getEventsRetrieveUrl = (id: string,) => {




  return `/api/events/${id}/`
}

/**
 * Event object describes an event at a venue (e.g. 'Pete & Amy's Wedding')
 */
export const eventsRetrieve = async (id: string, options?: Parameters<typeof customFetch>[1]): Promise<Event> => {

  return customFetch<Event>(getEventsRetrieveUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getEventsRetrieveQueryKey = (id: string,) => {
    return [
    `/api/events/${id}/`
    ] as const;
    }


export const getEventsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof eventsRetrieve>>, TError = void>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof eventsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getEventsRetrieveQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof eventsRetrieve>>> = ({ signal }) => eventsRetrieve(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof eventsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type EventsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof eventsRetrieve>>>
export type EventsRetrieveQueryError = void


export function useEventsRetrieve<TData = Awaited<ReturnType<typeof eventsRetrieve>>, TError = void>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof eventsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof eventsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof eventsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useEventsRetrieve<TData = Awaited<ReturnType<typeof eventsRetrieve>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof eventsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof eventsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof eventsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useEventsRetrieve<TData = Awaited<ReturnType<typeof eventsRetrieve>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof eventsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useEventsRetrieve<TData = Awaited<ReturnType<typeof eventsRetrieve>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof eventsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getEventsRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getEventsUpdateUrl = (id: string,) => {




  return `/api/events/${id}/`
}

/**
 * Event object describes an event at a venue (e.g. 'Pete & Amy's Wedding')
 */
export const eventsUpdate = async (id: string,
    eventRequest: EventRequest, options?: Parameters<typeof customFetch>[1]): Promise<Event> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<Event>(getEventsUpdateUrl(id),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(eventRequest)
  }
);}





export const getEventsUpdateMutationKey = () => ['eventsUpdate'] as const;

export const getEventsUpdateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof eventsUpdate>>, TError,EventsUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof eventsUpdate>>, TError,EventsUpdateMutationVariables, TContext> => {

const mutationKey = getEventsUpdateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof eventsUpdate>>, EventsUpdateMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  eventsUpdate(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type EventsUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof eventsUpdate>>>
    export type EventsUpdateMutationBody = EventRequest
    export type EventsUpdateMutationError = void
    export type EventsUpdateMutationVariables = {id: string;data: EventRequest}

    export const useEventsUpdate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof eventsUpdate>>, TError,EventsUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof eventsUpdate>>,
        TError,
        EventsUpdateMutationVariables,
        TContext
      > => {
      return useMutation(getEventsUpdateMutationOptions(options), queryClient);
    }
    export const getEventsPartialUpdateUrl = (id: string,) => {




  return `/api/events/${id}/`
}

/**
 * Event object describes an event at a venue (e.g. 'Pete & Amy's Wedding')
 */
export const eventsPartialUpdate = async (id: string,
    patchedEventRequest?: PatchedEventRequest, options?: Parameters<typeof customFetch>[1]): Promise<Event> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<Event>(getEventsPartialUpdateUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(patchedEventRequest)
  }
);}





export const getEventsPartialUpdateMutationKey = () => ['eventsPartialUpdate'] as const;

export const getEventsPartialUpdateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof eventsPartialUpdate>>, TError,EventsPartialUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof eventsPartialUpdate>>, TError,EventsPartialUpdateMutationVariables, TContext> => {

const mutationKey = getEventsPartialUpdateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof eventsPartialUpdate>>, EventsPartialUpdateMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  eventsPartialUpdate(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type EventsPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof eventsPartialUpdate>>>
    export type EventsPartialUpdateMutationBody = PatchedEventRequest | undefined
    export type EventsPartialUpdateMutationError = void
    export type EventsPartialUpdateMutationVariables = {id: string;data?: PatchedEventRequest}

    export const useEventsPartialUpdate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof eventsPartialUpdate>>, TError,EventsPartialUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof eventsPartialUpdate>>,
        TError,
        EventsPartialUpdateMutationVariables,
        TContext
      > => {
      return useMutation(getEventsPartialUpdateMutationOptions(options), queryClient);
    }
    export const getEventsDestroyUrl = (id: string,) => {




  return `/api/events/${id}/`
}

/**
 * Event object describes an event at a venue (e.g. 'Pete & Amy's Wedding')
 */
export const eventsDestroy = async (id: string, options?: Parameters<typeof customFetch>[1]): Promise<void> => {

  return customFetch<void>(getEventsDestroyUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getEventsDestroyMutationKey = () => ['eventsDestroy'] as const;

export const getEventsDestroyMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof eventsDestroy>>, TError,EventsDestroyMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof eventsDestroy>>, TError,EventsDestroyMutationVariables, TContext> => {

const mutationKey = getEventsDestroyMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof eventsDestroy>>, EventsDestroyMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  eventsDestroy(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type EventsDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof eventsDestroy>>>

    export type EventsDestroyMutationError = void
    export type EventsDestroyMutationVariables = {id: string}

    export const useEventsDestroy = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof eventsDestroy>>, TError,EventsDestroyMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof eventsDestroy>>,
        TError,
        EventsDestroyMutationVariables,
        TContext
      > => {
      return useMutation(getEventsDestroyMutationOptions(options), queryClient);
    }
